export const productKeys = {
  EMERGENCY_CARD: 'emergency-card',
  // EMERGENCY_CARD: 'emergency-card',
};
